import { ref } from "vue";
import { ngFrameworkLoaded } from "../../ng-integration";
import { getPlayerSelfExclusion } from "../../player/http-clients/player-account-http-client";
import { PanicButtonLocationType } from "../models/panic-button-types";

export const isSelfExcludedAccount = ref<boolean | null>(null);

export const startPanicButtonFlow = async (location: PanicButtonLocationType = "", game = "") => {
    const { usePanicButtonFlow } = await import("./use-panic-button-flow");
    const { showPopup } = usePanicButtonFlow();
    await showPopup(location, game);
};

export const initSelfExclusionButton = async () => {
    document.getElementById("panic-button")?.addEventListener("click", async () => {
        await ngFrameworkLoaded();
        startPanicButtonFlow("footer");
    });
};

/**
 * Runs the necessary actions tied to self exclusion after login.
 *
 * Should be the second check (after player account) in the after login flow.
 *
 * @returns true if the self exclusion popup was requested, false otherwise.
 */
export const selfExclusionAfterLogin = async (loggedIn: boolean | null) => {
    if (loggedIn) {
        let selfExclusion = null;
        try {
            selfExclusion = await getPlayerSelfExclusion();
        } catch {
            return;
        }

        const isPermanent = selfExclusion?.Limits?.[0]?.DurationUnit === "Permanent";
        const isTemporary = !!selfExclusion?.Limits?.[0]?.EndDate;

        isSelfExcludedAccount.value = isPermanent || isTemporary;

        if (!isSelfExcludedAccount.value) return;

        const { usePanicButtonLoginNotification } = await import("../core/use-panic-button-login-notification");
        const { showPermanentBlockPopup, showTemporaryBlockPopup } = usePanicButtonLoginNotification();

        if (isPermanent) {
            await showPermanentBlockPopup();
        } else if (isTemporary) {
            await showTemporaryBlockPopup(new Date(selfExclusion.Limits[0].EndDate));
        }
    } else {
        isSelfExcludedAccount.value = null;
    }

    return isSelfExcludedAccount.value;
};
